import type { FunctionComponent } from 'react'
import SvgCheck from '../../svg/icons/Check'
import style from './BoxCard.module.sass'

type BoxCardProps = {
	text: string
}

export const BoxCard: FunctionComponent<BoxCardProps> = ({ text }) => {
	return (
		<div className={style.wrapper}>
			<div className={style.iconWrapper}>
				<SvgCheck />
			</div>
			<p className={style.text}>{text}</p>
		</div>
	)
}
